import React, { useId } from "react";

const CustomDate = ({
  title,
  startDateLabel,
  endDateLabel,
  register,
  stateName,
  labelRequired = true,
  error,
  onStartDateChange,
  onEndDateChange,
  StartDateValue,
  EndDateValue,
  disabled = false,
}) => {
  const id = useId();

  return (
    <div className="w-fit mt-2 mb-4">
      {labelRequired && (
        <label className="text-sm">
          {title} {error && <span className="ml-4 text-red-600">*{error}</span>}
        </label>
      )}
      <div className="text-gray-400 flex pt-2">
        <div className="w-fit">
          <label htmlFor={id} className="block text-xs mb-2">
            {startDateLabel}
          </label>
          <input
            type="date"
            id={id}
            className="text-sm border-b-2 border-gray-300 focus:outline-none"
            {...register(stateName.startDate, {
              valueAsDate: true,
            })}
            value={StartDateValue}
            disabled={disabled}
            onChange={(e) => onStartDateChange(e.target.value)}
          />
        </div>
        <div className="mx-6 self-end text-xs">to</div>
        <div className="w-fit">
          <label className="block text-xs mb-2">{endDateLabel}</label>
          <input
            type="date"
            className="text-sm border-b-2 border-gray-300 focus:outline-none"
            {...register(stateName.endDate, {
              valueAsDate: true,
            })}
            value={EndDateValue}
            disabled={disabled}
            onChange={(e) => onEndDateChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomDate;
